import { useEffect, useRef } from "react"
import cable from "@/lib/cable"

type AccountEvent = {
  event: "credit_balance_updated"
  credit_balance: number
}

export function useAccountChannel(
  accountId: number | null | undefined,
  onCreditBalanceUpdated: (balance: number) => void,
) {
  const callbackRef = useRef(onCreditBalanceUpdated)

  useEffect(() => {
    callbackRef.current = onCreditBalanceUpdated
  })

  useEffect(() => {
    if (!accountId) return

    const subscription = cable.subscriptions.create(
      { channel: "AccountChannel" },
      {
        received(data: AccountEvent) {
          if (data.event === "credit_balance_updated") {
            callbackRef.current(data.credit_balance)
          }
        },
      },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [accountId])
}
